import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import useStore from '../../../store';
import { BASE_URL } from '../../../constants/endpoints';

interface IIbanResponse {
  account_number: string;
  bank_id: string;
  bic: string;
  branch_id: string;
  check_digits: string;
  country_code: string;
  iban: string;
  institution_name: string;
  national_id: string;
  usedIbanCode: string;
}

export const getIbanValidationData = () => {
  const { currUser, getPersonalAccountId } = useStore(state => state);

  return useMutation('ibanValidationData', async (iban: string) => {
    const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${currUser().customerId}/${getPersonalAccountId()}/international/wire/out/iban/${iban}`);
    data.usedIbanCode = iban;
    return data as IIbanResponse;
  });
};
